import React from 'react';

import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { isFeatureEnabled } from 'ff/common/ffAppUtils';
import { useDebriefApp } from 'ff/debrief/hooks';
import SidebarPanel from 'ff/debrief/layouts/SidebarPanel';
import SidebarTabs, { MINE } from './SidebarTabs';
import FilterBar from './FilterBar';
import TracklogList from './TracklogList';
import ImportsButton from 'ff/debrief/components/imports/ImportsButton';

const Sidebar = () => {
    const {
        filterStartTimestamp,
        filterEndTimestamp,
        fuzzySearchTerm,
        setFilterStartTimestamp,
        setFilterEndTimestamp,
        setFuzzySearchTerm,
    } = useDebriefApp();

    return (
        <SidebarPanel>
            <Stack spacing={1.5}>
                {isFeatureEnabled('new_share_debrief_feature') && (
                    <SidebarTabs currentTab={MINE} />
                )}
                <FilterBar
                    startTimestamp={filterStartTimestamp}
                    endTimestamp={filterEndTimestamp}
                    fuzzySearchTerm={fuzzySearchTerm}
                    onStartChange={setFilterStartTimestamp}
                    onEndChange={setFilterEndTimestamp}
                    onFuzzySearchChange={setFuzzySearchTerm}
                />
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <ImportsButton />
                </Box>
                <TracklogList
                    startTimestamp={filterStartTimestamp}
                    endTimestamp={filterEndTimestamp}
                    fuzzySearchTerm={fuzzySearchTerm}
                />
            </Stack>
        </SidebarPanel>
    );
};

export default Sidebar;
